function Error() {
  return (
    <div className="">
      <div className="row mt-3">
        <div className="col"></div>
        <div className="col col-span-3">
          <h1 className="fs-3 ">This function is on our to-do list!</h1>

          <p>
            Want to help us check off all the items on our list, and bring direct democracy to
            America?
          </p>
          <p>There are four ways to do that:</p>
          <ul>
            <li>Invest in the App</li>
            <li>Give to the nonprofit</li>
            <li>Volunteer (as an experienced professional)</li>
            <li>Apply for a paying job</li>
          </ul>
          <p>
            Just email us at{" "}
            <a href="mailto:democracystraightup@gmail.com">democracystraightup@gmail.com</a> {"  "}
            and we'll respond with more info.
          </p>
          <p>
            Otherwise, if you have signed up and joined a Circle, just sit tight and functions will
            appear as they are built. Ask your F-Del to let you know when new functions are
            introduced--we'll be in touch with them.
          </p>
        </div>
        <div className="col"></div>
      </div>
    </div>
  );
}

export default Error;
